import React, { memo } from 'react';

import styles from './Logo.css';
import { getAlt, getLogoSrc } from './Logo.helpers';
import { IProps } from './Logo.types';

export const LogoComponent = memo<IProps>(function LogoComponent({ withEndorsment = true, isBizUser, logoSrc: src }) {
    const logoSrc = getLogoSrc({ withEndorsment, isBizUser, logoSrc: src });
    const alt = getAlt(isBizUser);

    return (
        <a href="/" title={alt} className={styles.root} data-qa-button="logo">
            <img height={24} src={logoSrc} alt={alt} />
        </a>
    );
});
